<template>
  <header class="layout-head">
    <div class="layout_header_top def-w f-b-c fc99">
      <div class="top-left f-b-c">
        <span>您好，欢迎访问{{ site.name }}</span>
        <a :href="loginUrl" target="_blank" class="login">登录</a>
        <a :href="registerUrl" target="_blank">免费注册</a>
      </div>
      <div class="top-right fc33">
        咨询电话：<span>{{ site.consultHotline }}</span> （工作时间：{{
          site.workTime
        }}）
      </div>
    </div>
    <div class="layout_head_container">
      <div class="def-w f-b-c">
        <a href="/" :title="site.name">
          <img :src="site.logo" :alt="site.name" />
        </a>
        <head-search />
      </div>
    </div>
    <head-nav v-if="!$route.meta.hideNav" />
  </header>
</template>

<script>
import HeadSearch from "@/layout/components/LayoutHead/HeadSearch.vue";
import HeadNav from "@/layout/components/LayoutHead/HeadNav/index.vue";
import { mapGetters } from "vuex";

export default {
  name: "LayoutHead",
  components: { HeadNav, HeadSearch },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["site"]),
    loginUrl() {
      return process.env.VUE_APP_LOGIN_LINK;
    },
    registerUrl() {
      return process.env.VUE_APP_REGISTER_LINK;
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout-head {
  width: 100%;
  background-color: #f5f5f5;
  .layout_header_top {
    font-size: 12px;
    height: 40px;
    .top-left {
      > a {
        color: #9999;
        &:hover {
          color: $--color-primary;
        }
      }
      .login {
        margin-left: 10px;
        margin-right: 14px;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          bottom: 4px;
          right: -7px;
          width: 1px;
          height: 12px;
          background-color: #9999;
        }
      }
    }
  }
  .layout_head_container {
    background-color: #fff;
    .def-w {
      height: 100px;
    }
  }
}
</style>
